import React, { useState, useRef , useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Showcase.module.css';
import NavigationMenu from './NavigationMenu';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BlurredTextBox from './BlurredTextBox';
import { BeatLoader } from 'react-spinners';
import baseStyles from './Home.module.css'
import HelpPopup from './HelpPopup';
import WidgetCustomization from './WidgetCustomization';
import Reminder from './Reminder';
import NotificationComponent from './NotificationComponent';

function ShowcaseSpotify() {
  const [accessToken, setAccessToken] = useState(null);
  const [currentSong, setCurrentSong] = useState({
    name: "Start playing music on Spotify to preview!",
    artist: "super-stream.co",
    album: "Start playing music on Spotify to preview!",
    image: "/images/nosong.png", // Local image path in the public folder
  });
  const [widgetConfig, setWidgetConfig] = useState({
    layout: 'horizontal',
    backgroundColor: 'rgba(0, 0, 0, 1)',
    strokeColor: '#ffffff',
    textColor: '#ffffff',
    backgroundOpacity: 1,
    borderRadius: 10,
    showBackground: true,
    showStroke: true,
    showTitle: true,
    showArtist: true,
    showAlbum: true,
    showImage: true,
    fontFamily: 'Roboto'
  });
  const [errorMessage, setErrorMessage] = useState(null); // Manage the error message
  const pollingRef = useRef(null); // Track the polling interval
  const navigate = useNavigate();
  const [isSpotifyLoggedIn, setIsSpotifyLoggedIn] = useState(false); // State for tracking login status
  const [isLoading, setIsLoading] = useState(true); // State for tracking loading status
  const [imageUrl, setImageUrl] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status
  const [authToken, setAuthToken] = useState('');
  const location = useLocation();
  const user = location.state?.user;
  const csrfState = Math.random().toString(36).substring(2);
  const [authWindow, setAuthWindow] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState(""); // Stores different messages
  var sideNavSize = 300;

  const defaultSong = {
    name: "Start playing music on Spotify to preview!",
    artist: "super-stream.co",
    album: "Start playing music on Spotify to preview!",
    image: "/images/nosong.png", // Local image path in the public folder
  };
  
  const mergedSong = { ...defaultSong, ...currentSong };

  useEffect(() => {
    const loadWidgetConfig = async () => {
      try {
        const userId = localStorage.getItem('_id');
        if (!userId) return;
        console.log("default widget info is: ", widgetConfig);
        const response = await axios.get(`https://dev.super-stream.co/api/getSpotifySettings/${userId}`);
        console.log("response is: ", response);
        console.log("settings is: ", response.data.settings);

        if (response.data && response.data.settings) {
          
          setWidgetConfig((prevConfig) => ({
            ...prevConfig,  // Preserve any missing fields with default values
            ...response.data.settings, // Override with saved settings
          }));
        }

      } catch (error) {
        console.error("Error loading widget settings:", error);
      }
    };
  
    loadWidgetConfig();
  }, []);

//   // Watch for `authToken` changes and fetch the access token when it is set
// useEffect(() => {
//   const fetchAccessToken = async () => {
//     console.log("FETCH ACCESS TOKEN", authToken);

//     if (authToken) {
//       try {
//         await GetAccessTokenSpotify(authToken); // Fetch the access token
//         setIsSpotifyLoggedIn(true); // Set logged-in state
//       } catch (error) {
//         console.error("Error fetching access token:", error);
//         setIsSpotifyLoggedIn(false); // Handle error state
//       }
//     }
//   };

//   fetchAccessToken();
// }, [authToken]); // Run this effect whenever `authToken` changes

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        console.log("Initializing auth...");
        const token = await checkTokenValidity();
        if (token) {
          setAccessToken(token);
          console.log("Access token set:", token);
        } else {
          console.error("Failed to retrieve access token.");
        }
      } catch (error) {
        console.error("Error during auth initialization:", error);
      }
    };
  
    initializeAuth();
  }, []);

  useEffect(() => {
    // Check if user returned from Spotify login
    const authPending = localStorage.getItem("spotifyAuthPending");
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code"); 
    const returnedState = urlParams.get('state');
    const savedState = localStorage.getItem("csrfState");

    if(authPending === "true" && code){
      validateState(returnedState, savedState);
      GetAccessTokenSpotify(code).then((token) => {
        setAccessToken(token);
        if (authPending === "true" && token) {
            setIsSpotifyLoggedIn(true); // Update state
            localStorage.setItem("spotifyLoggedIn", "true"); // Store login status
            localStorage.removeItem("spotifyAuthPending"); // Clear flag
            setAuthToken(token); // Store the token
            // need to save spotify token to server and retrieve it to see if logged in
            
            navigate("/showcasespotify", { replace: true }); // Remove token from URL
        }
      });
    } else{
      const isLoggedIn = localStorage.getItem("spotifyLoggedIn") === "true";
      setIsSpotifyLoggedIn(isLoggedIn);
    }
           
  }, [navigate]);

  useEffect(() => {
    const loadWidgetConfig = async () => {
      try {
        
        // Fetch Spotify settings from the backend
        const response = await fetch(`https://dev.super-stream.co/api/getSpotifySettings/${localStorage.getItem('_id')}`);

        if (!response.ok) {
          throw new Error("Failed to fetch settings");
        }

        const data = await response.json();

        if (data.settings) {
          setWidgetConfig(data.settings);
        } else {
          setDefaultWidgetSettings();
        }
      } catch (error) {
        console.error("Error loading widget configuration:", error);
      }
    };

    const userId = localStorage.getItem('_id');
    if (userId) {
      loadWidgetConfig();
    }
  }, []);

  // Save widget configuration and trigger a source check
  const saveWidgetConfig = async () => {
    try {
      console.log("saving widget config spotify");
      console.log(localStorage.getItem('_id'));
      console.log(widgetConfig);

      // need to save for user on superstream server
      const response = await axios.put("https://dev.super-stream.co/api/spotifySaveSettings", {
        userId: localStorage.getItem('_id'),
        SpotifyWidgetConfig: widgetConfig,
      });
      // await window.Streamlabs.userSettings.set('widgetConfig', JSON.stringify(widgetConfig));
      console.log("Widget config saved.");
      setNotificationMessage("Widget customisation values saved.")
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage("")
      }, 3000); // Hide notification after 3 seconds
    } catch (error) {
      console.error("Error saving widget configuration:", error);
    }
  }


  useEffect(() => {
    const refreshInterval = setInterval(async () => {
      // get settings api
      // let settings = await window.Streamlabs.userSettings.getAll();
      // const expirationTime = settings['token_expiration'];
      // if (Date.now() >= expirationTime - 60000) {
      //   const token = await refreshSpotifyToken();
      //   if (token) setAccessToken(token);
      // }
    }, 60000);

    return () => clearInterval(refreshInterval);
  }, []);

  useEffect(() => {
    if (accessToken) {
      fetchCurrentSong();
      const songInterval = setInterval(fetchCurrentSong, 5000); // Poll for song updates
      return () => clearInterval(songInterval);
    }
  }, [accessToken]);

async function GetAccessTokenSpotify(spotifyToken){
  console.log("GETTING ACCESS TOKEN YOOOO");
  console.log("GETTING ACCESS TOKEN YOOOO", spotifyToken);
  const decodedToken = decodeURI(spotifyToken);

  const firstUrl = "https://dev.super-stream.co/api/getSpotifyAccessToken/";

  let responseLong = await fetch(firstUrl, {
      method: 'POST', // ✅ Use POST to send data
      headers: {
          'Content-Type': 'application/json', // ✅ Correct content type
      },
      body: JSON.stringify({
          authorizationCode: decodedToken, // ✅ Send as JSON body
          userId: localStorage.getItem("_id"), // ✅ Ensure you send the user ID too
      }),
  });

  let dataLong = await responseLong.json();
  return dataLong.access_token;
}

  const handleSpotifyLogin = () => {
    const csrfState = Math.random().toString(36).substring(2, 15);
    localStorage.setItem("csrfState", csrfState);
    openSpotifyAuth(csrfState);
  };

  const setDefaultWidgetSettings = () => {
    setWidgetConfig({
      layout: 'horizontal',
      backgroundColor: 'rgb(143, 143, 143)',
      strokeColor: '#ffffff',
      textColor: '#ffffff',
      backgroundOpacity: 13,
      borderRadius: 10,
      showBackground: true,
      showStroke: true,
      showTitle: true,
      showArtist: true,
      showAlbum: true,
      showImage: true,
    });
  }

  const startPolling = () => {
    if (!pollingRef.current) {
      pollingRef.current = setInterval(async () => {
        if (!accessToken) {
          console.log("Access token not yet available, skipping this poll cycle.");
          return;
        }
      }, 5000);
      console.log("Started polling for widget source.");
    }
  };

  const openSpotifyAuth = (csrfState) => {
    const spotifyAuthUrl = buildSpotifyAuthUrl(csrfState);
    
    // Store login intent in localStorage before redirecting
    localStorage.setItem("spotifyAuthPending", "true");

    // Redirect to TikTok login page
    window.location.href = spotifyAuthUrl;
  };

  const buildSpotifyAuthUrl = (csrfState) => {
    const clientId = '473aa96d7e20404496ec5d5fd79ed4b6';
    const redirectUri = encodeURIComponent('https://dev.super-stream.co/showcasespotify/');
    const scopes = encodeURIComponent('user-read-private user-read-email user-read-currently-playing');
    const responseType = 'code';

    return `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&scope=${scopes}&state=${csrfState}`;
  };

  const validateState = (receivedState, expectedState) => {
    console.log("Received state:", receivedState);
    console.log("Expected state:", expectedState);
    if (receivedState !== expectedState) {
      throw new Error('State mismatch. Potential CSRF detected.');
    }
  };

  

  const checkTokenValidity = async () => {
    try {
        // 🔹 Retrieve user ID from SuperStream settings (localStorage or API call)
        const userId = localStorage.getItem("_id");  // Change this if stored elsewhere

        if (!userId) {
            console.error("❌ No user ID found. User needs to log in.");
            return null;
        }

        // 🔹 Call backend to check token validity
        const response = await fetch('https://dev.super-stream.co/api/refreshSpotifyToken/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId }),
        });

        const data = await response.json();

        if (!response.ok) {
            console.error("❌ Token check failed:", data.error);
            return null;
        }

        console.log("✅ Valid Spotify access token:", data.access_token);
        return data.access_token;

    } catch (error) {
        console.error("❌ Error checking token validity:", error);
        return null;
    }
};


  const fetchCurrentSong = async () => {
    if (!accessToken) return;
  
    try {
      const response = await fetch('https://api.spotify.com/v1/me/player/currently-playing', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
  
      if (response.ok) {
        const data = await response.json();
        // for testing
        // data = [];
        if (data && data.item) {
          // Song data exists
          setCurrentSong({
            name: data.item.name,
            artist: data.item.artists.map((artist) => artist.name).join(', '),
            album: data.item.album.name,
            image: data.item.album.images[0].url,
          });
        } else {
          // No song is playing
          setCurrentSong({
            name: "Start playing music on Spotify to preview!",
            artist: "super-stream.co",
            album: "Start playing music on Spotify to preview!",
            image: "/images/nosong.png", // Local image path in the public folder
          });
        }
      } else {
        console.error('Failed to fetch currently playing song:', await response.text());
        // Set default values if the request fails
        setCurrentSong({
          name: "Start playing music on Spotify to preview!",
          artist: "super-stream.co",
          album: "Start playing music on Spotify to preview!",
          image: "/images/nosong.png", // Local image path in the public folder
        });
      }
    } catch (error) {
      console.error('Error fetching current song:', error);
      // Set default values if there's an error
      setCurrentSong({
        name: "Start playing music on Spotify to preview!",
        artist: "super-stream.co",
        album: "Start playing music on Spotify to preview!",
        image: "/images/nosong.png", // Local image path in the public folder
      });
    }
  };
  

  const handleConfigChange = (key, value) => {
    setWidgetConfig((prev) => ({ ...prev, [key]: value }));
  };

  const handleBackgroundColorChange = (color) => {
    const rgbaColor = convertHexToRGBA(color, widgetConfig.backgroundOpacity);
    setWidgetConfig((prev) => ({ ...prev, backgroundColor: rgbaColor }));
  };
  
  const handleOpacityChange = (opacity) => {
    const rgbaColor = convertHexToRGBA(convertRGBAtoHex(widgetConfig.backgroundColor), opacity);
    setWidgetConfig((prev) => ({
      ...prev,
      backgroundOpacity: opacity,
      backgroundColor: rgbaColor,
    }));
  };

  const convertHexToRGBA = (hex, opacity) => {
    let r = 0,
      g = 0,
      b = 0;
  
    // Convert hex to RGB
    if (hex.length === 7) {
      r = parseInt(hex.slice(1, 3), 16);
      g = parseInt(hex.slice(3, 5), 16);
      b = parseInt(hex.slice(5, 7), 16);
    }
  
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };
  
  const convertRGBAtoHex = (rgba) => {
    const result = rgba.match(/rgba?\((\d+), (\d+), (\d+),? ?([\d.]+)?\)/);
    if (!result) return '#000000';
  
    const r = parseInt(result[1]).toString(16).padStart(2, '0');
    const g = parseInt(result[2]).toString(16).padStart(2, '0');
    const b = parseInt(result[3]).toString(16).padStart(2, '0');
  
    return `#${r}${g}${b}`;
  };
  
  const handleLogout = async () => {
    try {
        // 🔹 Get userId from context, state, or localStorage
        const userId = localStorage.getItem("_id"); // Adjust as needed

        if (!userId) {
            console.error("No userId found, skipping API call.");
        } else {
            // 🔹 Call the backend API to remove Spotify credentials
            const response = await fetch("https://dev.super-stream.co/api/removeSpotifyCredentials/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ userId }),
            });

            if (!response.ok) {
                console.error("Failed to remove Spotify credentials:", await response.text());
            }
        }

        // 🔹 Clear tokens from local storage
        localStorage.removeItem("spotifyAccessToken");
        localStorage.removeItem("spotifyRefreshToken");
        localStorage.removeItem("userId");

        // 🔹 Clear the accessToken from state
        setAccessToken(null);

        // 🔹 Optionally, clear any other related state
        setCurrentSong(null);
        setIsSpotifyLoggedIn(false);
        console.log("User logged out and Spotify credentials removed.");

    } catch (error) {
        console.error("Error during logout:", error);
    }
};

  

  return (
    <div className={`container-fluid`}>
          <div className="row">
              <div className="col">
                    <div className="row">
                      <div className={`col-2 nonScrollable ${isCollapsed ? `hideSidebar` : `showSidebar`}`}  style={{paddingRight: 0, paddingLeft: 0, width: sideNavSize + 'px'}}>
                            <NavigationMenu />
                      </div>
                      <div className={` col scrollable ${isCollapsed ? 'col-12' : ''}`} style={{ order: 1 }}>
                        <div className="scrollableContent">

                        





    <div className={styles["App"]}>
      <img src="/images/bannershowcasespotify.png" className={styles["responsive-image"]}></img>
      {errorMessage && (
        <div className={styles["error-message"]}>
          <p style={{fontWeight: 'bold'}}>{errorMessage}</p>
        </div>
      )}
     
      {!accessToken ? (
        <div className={styles["pre-login-container"]}>
          {/* Placeholder Image */}

          {/* Text and Button Section */}
            {/* <h1 className={styles["title-text"]} style={{color: '#ffffff'}}>Vibe with viewers using the power of music. </h1>
            <p className={styles["sub-text"]} style={{color: '#ffffff'}}>Set the mood by showing-off what you're listening to 🎸🎧</p> */}
            <button className={styles["button"]} onClick={handleSpotifyLogin}>
              Login with Spotify
            </button>
        </div>
      ) : (
        null
      )}

    <HelpPopup 
      videoUrl="https://www.youtube.com/embed/AbyqFGWe8SQ?si=6qLpWsY1uKuu1KEx" 
      buttonLabel="?"
      popupTitle="Need Assistance?"
      popupMessage="Check out the tutorial below:"
      isSpotifyLoggedIn={isSpotifyLoggedIn} 
      TiktokLogOut={handleLogout}
      buttonText='Remove Spotify Account'
    />
 {showNotification && (
        <NotificationComponent message={notificationMessage} setShowNotification={setShowNotification} />
      )}

    <div className={styles["optionspreviewrow"]}>
            <div className={styles["widget-customization"]}>
              <h3 style={{color: '#FECB00'}}>Widget URL</h3>
              <BlurredTextBox text={"https://dev.super-stream.co/api/showcasespotify/" + localStorage.getItem("_id")} setShowNotification={setShowNotification} setNotificationMessage={setNotificationMessage}></BlurredTextBox>
            </div>

            <div className={styles["customization-preview-container"]}>
              {/* Widget Customization Section */}
              <div className={styles["widget-customization"]}>
              <h3>Widget Customization</h3>
              <div className={`styles.button d-flex justify-content-center`}>
                <button onClick={saveWidgetConfig} type="button" className={`styles.button d-flex justify-content-center`} style={{marginBottom: '20px'}}>Save</button>
              </div>
              {/* Layout Settings */}
              <div className={styles["config-group"]}>
                <h4>Layout Settings</h4>
                <label>
                  Layout:
                  <select
                    value={widgetConfig.layout}
                    onChange={(e) => handleConfigChange('layout', e.target.value)}
                  >
                    <option value="horizontal">Horizontal</option>
                    <option value="vertical">Vertical</option>
                  </select>
                </label>
              </div>

              {/* Background Settings */}
              <div className={styles["config-group"]}>
                <h4>Background Settings</h4>
                <label>
                  <input
                    type="checkbox"
                    checked={widgetConfig.showBackground}
                    onChange={(e) => handleConfigChange('showBackground', e.target.checked)}
                  />
                  Enable Background
                </label>
                <label>
                  Background Color:
                  <input
                    type="color"
                    value={convertRGBAtoHex(widgetConfig.backgroundColor)}
                    onChange={(e) => handleBackgroundColorChange(e.target.value)}
                    disabled={!widgetConfig.showBackground}
                  />
                </label>
                <label>
                  Background Opacity:
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={widgetConfig.backgroundOpacity}
                    onChange={(e) => handleOpacityChange(parseFloat(e.target.value))}
                    disabled={!widgetConfig.showBackground}
                  />
                </label>
              </div>

              {/* Border Settings */}
              <div className={styles["config-group"]}>
                <h4>Border Settings</h4>
                <label>
                  <input
                    type="checkbox"
                    checked={widgetConfig.showStroke}
                    onChange={(e) => handleConfigChange('showStroke', e.target.checked)}
                  />
                  Enable Border
                </label>
                <label>
                  Border Color:
                  <input
                    type="color"
                    value={widgetConfig.strokeColor}
                    onChange={(e) => handleConfigChange('strokeColor', e.target.value)}
                    disabled={!widgetConfig.showStroke}
                  />
                </label>
                <label>
                  Border Radius:
                  <input
                    type="range"
                    min="0"
                    max="30"
                    step="1"
                    value={widgetConfig.borderRadius}
                    onChange={(e) => handleConfigChange('borderRadius', parseInt(e.target.value, 10))}
                  />
                  <span>{widgetConfig.borderRadius}px</span>
                </label>
              </div>

              {/* Content Display Settings */}
              <div className={styles["config-group"]}>
                <h4>Content Display</h4>
                <label>
                  <input
                    type="checkbox"
                    checked={widgetConfig.showTitle}
                    onChange={(e) => handleConfigChange('showTitle', e.target.checked)}
                  />
                  Show Song Title
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={widgetConfig.showArtist}
                    onChange={(e) => handleConfigChange('showArtist', e.target.checked)}
                  />
                  Show Artist
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={widgetConfig.showAlbum}
                    onChange={(e) => handleConfigChange('showAlbum', e.target.checked)}
                  />
                  Show Album
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={widgetConfig.showImage}
                    onChange={(e) => handleConfigChange('showImage', e.target.checked)}
                  />
                  Show Song Image
                </label>
              </div>

              {/* Text Settings */}
              <div className={styles["config-group"]}>
                <h4>Text Settings</h4>
                <label>
                  Text Color:
                  <input
                    type="color"
                    value={widgetConfig.textColor}
                    onChange={(e) => handleConfigChange('textColor', e.target.value)}
                  />
                </label>
                <label>
                  Font:
                  <select
                    value={widgetConfig.fontFamily || 'Roboto'}
                    onChange={(e) => handleConfigChange('fontFamily', e.target.value)}
                  >
                    <option value="Roboto">Roboto</option>
                    <option value="Arial">Arial</option>
                    <option value="Helvetica">Helvetica</option>
                    <option value="Times New Roman">Times New Roman</option>
                    <option value="Courier New">Courier New</option>
                  </select>
                </label>
              </div>
              <div className={`styles.button d-flex justify-content-center`}>
                <button onClick={saveWidgetConfig} type="button" className={`styles.button d-flex justify-content-center`} style={{marginBottom: '20px'}}>Save</button>
              </div>
            </div>


              <div className={styles['widget-preview-container']} 
              style={{flex: '1',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
              }}> 
                <h3 style={{color: '#FECB00'}}>Widget Preview</h3>
                <div
                  className={styles["widget-preview"]}
                  style={{
                    position: 'relative', // <-- Add this
                    display: 'flex',
                    flexDirection: widgetConfig.layout === 'horizontal' ? 'row' : 'column',
                    alignItems: 'center',
                    padding: '10px',
                    backgroundColor: widgetConfig.showBackground
                      ? widgetConfig.backgroundColor
                      : 'transparent',
                    border: widgetConfig.showStroke ? `2px solid ${widgetConfig.strokeColor}` : 'none',
                    borderRadius: `${widgetConfig.borderRadius}px`,
                    color: widgetConfig.textColor,
                    overflow: "hidden",
                    width: widgetConfig.layout === 'horizontal' ? '400px' : '300px',
                  }}
                >
                  {widgetConfig.showImage && (
                    <div
                      style={{
                        width: widgetConfig.layout === 'horizontal' ? '100px' : '200px',
                        height: widgetConfig.layout === 'horizontal' ? '100px' : '200px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '10px',
                        padding: '10px',
                        marginRight: widgetConfig.layout === 'horizontal' ? '10px' : '0',
                        marginBottom: widgetConfig.layout === 'horizontal' ? '0' : '10px',
                        aspectRatio: '1 / 1', // Enforce a square container
                      }}
                    >
                      <img
                        src={currentSong?.image || "/images/nosong.png"}
                        alt="Album Art"
                        style={{
                          width: widgetConfig.layout === 'horizontal' ? '100px' : '200px',
                          height: widgetConfig.layout === 'horizontal' ? '100px' : '200px',
                          objectFit: 'cover', // Ensure the image covers the container without distortion
                          borderRadius: '5px', // Optional: Round the corners
                          aspectRatio: '1 / 1', // Ensure a square aspect ratio
                          overflow: 'visible !important'
                        }}
                      />
                    </div>
                  )}
                  <div
                    style={{
                      textAlign: widgetConfig.layout === 'horizontal' ? 'left' : 'center',
                      overflow: 'hidden', // Hides content beyond container
                      whiteSpace: 'nowrap', // Prevents wrapping to a new line
                      textOverflow: 'ellipsis', // Adds ellipsis for truncated text
                      width: '100%', // Stretch to fill container
                      maxWidth: '280px', // Constrain width for ellipsis
                      flexShrink: 0, // Prevent shrinking due to flexbox
                    }}
                  >
                    {widgetConfig.showTitle && (
                      <p
                        style={{
                          margin: 0,
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          fontFamily: widgetConfig.fontFamily
                        }}
                      >
                        {currentSong?.name || "Start playing music on Spotify to preview!"}
                      </p>
                    )}
                    {widgetConfig.showArtist && (
                      <p
                        style={{
                          margin: 0,
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          fontFamily: widgetConfig.fontFamily
                        }}
                      >
                        {currentSong?.artist || "super-stream.co"}
                      </p>
                    )}
                    {widgetConfig.showAlbum && (
                      <p
                        style={{
                          margin: 0,
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          fontStyle: 'italic',
                          fontFamily: widgetConfig.fontFamily
                        }}
                      >
                        {currentSong?.album || "Start playing music on Spotify to preview!"}
                      </p>
                    )}
                  </div>
                  <img
                    src="/images/spotify.png"
                    alt="Spotify logo"
                    style={{
                      position: 'absolute',
                      bottom: '5px',
                      right: '5px',
                      width: '20px',
                      height: '20px',
                      opacity: 0.8, // optional: subtle transparency
                    }}
                  />

                </div>
                  <Reminder/>
              </div>
              {/* Widget Preview Section */}
            </div>
          
        
        </div>
    </div>
    </div>
                      </div>
                    </div>
            </div>
      </div>
      </div>

  );
}

export default ShowcaseSpotify;